module.exports = __webpack_public_path__ + "img/incident_report.cadab8c9.png";